module.exports = __webpack_public_path__ + "assets/img/close_x.ea6178e0.svg";